/**
 * Formats a date string to locale date format (e.g., "1/15/2024")
 */
export function formatDate(dateString: string): string {
  return new Date(dateString).toLocaleDateString();
}

/**
 * Formats a date string to locale date-time format (e.g., "1/15/2024, 2:30:00 PM")
 * Returns empty string for null/undefined values.
 */
export function formatDateTime(dateString: string | null | undefined): string {
  if (!dateString) return "";
  return new Date(dateString).toLocaleString();
}
